import React from "react";

// Bottom navigation, mirroring Android's BottomBar: each slot stacks the icon
// over a short label, and the active slot is tinted (label in primary, icon at
// full opacity) so the current tab is identifiable without a top-bar title.
const DynamicBottomBar = ({ menuItems, selectedTab }) => {
  if (menuItems.length < 3 || menuItems.length > 7) {
    throw new Error("DynamicBottomBar expects between 3 to 7 menu items.");
  }

  return (
    <div style={styles.bottomBar}>
      {menuItems.map((item, index) => {
        const selected = index === selectedTab;
        return (
          <button
            key={index}
            onClick={item.onClick}
            style={styles.button}
            aria-label={item.label}
          >
            <img
              src={item.icon}
              alt=""
              style={{ ...styles.icon, opacity: selected ? 1 : 0.55 }}
            />
            <span
              style={{
                ...styles.label,
                color: selected ? "var(--primary)" : "var(--text-muted)",
                fontWeight: selected ? 700 : 500,
              }}
            >
              {item.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

const styles = {
  bottomBar: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    height: "60px",
    boxSizing: "border-box",
    backgroundColor: "var(--bar)",
    borderTop: "1px solid var(--border)",
    position: "fixed",
    bottom: "0",
    width: "100%",
    zIndex: 1000,
  },
  button: {
    background: "transparent",
    border: "none",
    outline: "none",
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
    padding: "4px 2px",
    flex: 1,
    minWidth: 0,
  },
  icon: {
    width: "22px",
    height: "22px",
    filter: "var(--icon-filter)",
  },
  label: {
    fontSize: "10px",
    lineHeight: 1,
    whiteSpace: "nowrap",
  },
};

export default DynamicBottomBar;
